import { Card } from "@/components/ui/card";
import Styles from "./EventsCards.module.css";
import Image from "next/image";
import {
 
  Link,
  
} from "next/link";
// import Loader from "../Loader/Loader";
// import { convertToWebp } from "../../utils/Images/utlToWebp";
// import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
// import { useRouter } from "next/router";
export default function ContentCards({ imgSrc, Category, title, date }) {
  // const router = useRouter();
  // const { locale } = router;
  const BaseLink = "/storage/" + imgSrc;
  return (
    <Card className={Styles.CardsContainer}>
      <div>
        <div
          // component="img"
          // height="140"
          className={Styles.CardsImage}
        >
          <Image
            // component="img"
            // height="140"
            // className={Styles.CardsImage}
            fill
            // loader={Loader}
            src={BaseLink}
            alt={title}
            className="object-fill w-full h-full rounded-lg"
            style={{
              // width: "100%",
              // maxWidth: "100%",
              // transform: "translate(-80px,0)",
              // height: "auto",
              // position: "absolute",
              zIndex: 1,
            }}
          />
        </div>
      </div>
      <Link href={"/Apps/signup"}>
        <div
          className={Styles.CardsContentF}
          // style={{ padding: "1rem 0!important" }}
        >
          <div className={Styles.TextSlider}>
            <div className={Styles.TitleSections}>
              <h3 className={Styles.Title}>{title}</h3>
            </div>

            <div className={Styles.ButtonCards}>
              <div className="JoinUsButton">
                {/* <Link href={"/Apps/signup"}> */}
                <div className="ButtonVariantOne" style={{ width: "100%" }}>
                  JOIN US NOW
                </div>
                {/* </Link> */}
              </div>
            </div>

            <div className="">
              <span></span>
            </div>
          </div>
        </div>
      </Link>
    </Card>
  );
}
